import produce from 'immer';
import {
	HTTP_DELETE,
	HTTP_GET,
	HTTP_POST,
	HTTP_PUT,
	HTTP_REQUEST_COMPLETE
} from './http.actions';
import { HttpAction, IHttpState, SectionLoadingState } from './http.types';

export const httpInitialState: IHttpState = {
	state: {}
};

export function httpReducer(
	state: IHttpState = httpInitialState,
	action: HttpAction
): IHttpState {
	switch (action.type) {
		case HTTP_GET: {
			return setSectionState(
				state,
				action.payload as SectionLoadingState
			);
		}
		case HTTP_POST: {
			return setSectionState(
				state,
				action.payload as SectionLoadingState
			);
		}
		case HTTP_PUT: {
			return setSectionState(
				state,
				action.payload as SectionLoadingState
			);
		}
		case HTTP_DELETE: {
			return setSectionState(
				state,
				action.payload as SectionLoadingState
			);
		}
		case HTTP_REQUEST_COMPLETE: {
			return setSectionState(
				state,
				action.payload as SectionLoadingState
			);
		}
		default:
			return state;
	}
}

function setSectionState(
	currentState: IHttpState,
	sectionState: SectionLoadingState
): IHttpState {
	return produce(currentState, (draftState: IHttpState) => {
		draftState.state[sectionState.name] = sectionState;
	});
}
